export class ActivityByDateApi
{
    dateExec: string;
    nbJobs: number;
    nbFullyJobs: number;
    nbPartiallyJobs: number;
    nbFailedJobs: number;
}
